(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var panel = drawer ? drawer.querySelector('[data-cart-drawer-panel]') : null;
  var itemsEl = drawer ? drawer.querySelector('[data-cart-drawer-items]') : null;
  var titleEl = drawer ? drawer.querySelector('[data-cart-drawer-title]') : null;
  var noteEl = drawer ? drawer.querySelector('[data-cart-drawer-note]') : null;
  var subtotalEl = drawer ? drawer.querySelector('[data-cart-drawer-subtotal]') : null;
  var subtotalLabelEl = drawer ? drawer.querySelector('[data-cart-drawer-subtotal-label]') : null;
  var totalEl = drawer ? drawer.querySelector('[data-cart-drawer-total]') : null;
  var shippingMsgEl = drawer ? drawer.querySelector('[data-cart-drawer-shipping-msg]') : null;
  var progressEl = drawer ? drawer.querySelector('[data-cart-drawer-progress]') : null;
  var progressLabelEl = drawer ? drawer.querySelector('[data-cart-drawer-progress-label]') : null;
  var checkoutBtn = drawer ? drawer.querySelector('[data-cart-drawer-checkout]') : null;

  var threshold = drawer
    ? parseInt(drawer.getAttribute('data-free-shipping-threshold'), 10) || 3000000
    : 3000000;
  var noteTimer = null;
  var isOpen = false;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(
        cents,
        window.theme && theme.moneyFormat ? theme.moneyFormat : '${{amount}}'
      );
    }
    var amount = (cents / 100).toFixed(0);
    return '\u20B9 ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function ensureCartCountNodes() {
    if (document.querySelector('[data-cart-count-bubble]')) return;
    var bubble = document.createElement('div');
    bubble.className = 'visually-hidden';
    bubble.setAttribute('data-cart-count-bubble', '');
    bubble.setAttribute('aria-hidden', 'true');
    var count = document.createElement('span');
    count.setAttribute('data-cart-count', '');
    count.textContent = '0';
    bubble.appendChild(count);
    document.body.appendChild(bubble);
  }

  function updateCartCount(count) {
    ensureCartCountNodes();
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function (bubble) {
      if (count > 0) {
        bubble.classList.remove('hide');
      } else {
        bubble.classList.add('hide');
      }
    });
  }

  function resizeCartImage(url) {
    if (!url) return '';
    var src = url.indexOf('//') === 0 ? 'https:' + url : url;
    return src.replace(/(\.(jpg|jpeg|gif|png|webp))(\?.*)?$/i, '_160x$1$3');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  var removeIconSvg =
    '<svg class="tsw-cart-drawer__item-remove-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function renderItems(cart) {
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML =
        '<p class="tsw-cart-drawer__empty" data-cart-drawer-empty>Your cart is empty.</p>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var image = item.image
        ? '<img src="' +
          escapeHtml(resizeCartImage(item.image)) +
          '" alt="" width="80" height="100" loading="lazy">'
        : '';
      var variantLine =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="tsw-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';

      var qtyMax = Math.max(10, item.quantity);
      var qtyOptions = '';
      for (var q = 1; q <= qtyMax; q++) {
        qtyOptions +=
          '<option value="' + q + '"' + (Number(item.quantity) === q ? ' selected' : '') + '>' + q + '</option>';
      }

      html +=
        '<div class="tsw-cart-drawer__item" data-cart-drawer-item data-key="' +
        escapeHtml(item.key) +
        '" data-line="' +
        line +
        '">' +
        '<a href="' +
        escapeHtml(item.url) +
        '" class="tsw-cart-drawer__item-image">' +
        image +
        '</a>' +
        '<div class="tsw-cart-drawer__item-info">' +
        '<div class="tsw-cart-drawer__item-top">' +
        '<a href="' +
        escapeHtml(item.url) +
        '" class="tsw-cart-drawer__item-title">' +
        escapeHtml(item.product_title) +
        '</a>' +
        '<div class="tsw-cart-drawer__item-price-row">' +
        '<span class="tsw-cart-drawer__item-price">' +
        formatMoney(item.final_line_price) +
        '</span>' +
        '<button type="button" class="tsw-cart-drawer__item-remove" data-cart-drawer-remove="' +
        escapeHtml(item.key) +
        '" aria-label="Remove">' +
        removeIconSvg +
        '</button>' +
        '</div></div>' +
        variantLine +
        '<label class="tsw-cart-drawer__qty-label"><span>Qty:</span>' +
        '<select class="tsw-cart-drawer__qty-select" data-cart-drawer-qty data-item-key="' +
        escapeHtml(item.key) +
        '" data-current-qty="' +
        item.quantity +
        '">' +
        qtyOptions +
        '</select></label></div></div>';
    });

    itemsEl.innerHTML = html;
  }

  function isShippingProgressEnabled() {
    return drawer && drawer.getAttribute('data-show-shipping-progress') === 'true';
  }

  function updateShipping(cart) {
    if (!drawer || !isShippingProgressEnabled()) return;
    var total = cart.total_price || 0;
    var remaining = Math.max(threshold - total, 0);
    var pct = Math.min(Math.round((total / threshold) * 100), 100);

    if (shippingMsgEl) {
      shippingMsgEl.textContent =
        remaining > 0
          ? 'You are ' + formatMoney(remaining) + ' away from free shipping!'
          : "You've unlocked free shipping!";
    }
    if (progressEl) progressEl.style.width = pct + '%';
    if (progressLabelEl) {
      progressLabelEl.textContent = formatMoney(total) + ' / ' + formatMoney(threshold);
    }
  }

  function renderCart(cart) {
    if (titleEl) titleEl.textContent = 'YOUR CART (' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (subtotalLabelEl) {
      subtotalLabelEl.textContent =
        'Subtotal (' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ')';
    }
    if (noteEl && cart.note !== undefined && document.activeElement !== noteEl) {
      noteEl.value = cart.note || '';
    }
    updateCartCount(cart.item_count);
    updateShipping(cart);
    renderItems(cart);

    if (drawer) {
      if (cart.item_count === 0) {
        drawer.classList.add('is-empty');
      } else {
        drawer.classList.remove('is-empty');
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function isCartResponse(data) {
    return data && Array.isArray(data.items);
  }

  function updateQuantity(key, quantity) {
    var updates = {};
    updates[key] = quantity;

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || !isCartResponse(data)) {
          var err = new Error('Cart update failed');
          err.cart = data;
          throw err;
        }
        return data;
      });
    });
  }

  function updateNote(note) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note }),
    }).then(function (r) {
      return r.json();
    });
  }

  function openDrawer() {
    if (!drawer) return;
    if (isOpen) {
      fetchCart().then(renderCart).catch(function () {});
      return;
    }
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tsw-cart-drawer-open');

    fetchCart().then(renderCart).catch(function () {});

    window.setTimeout(function () {
      if (panel) panel.focus();
    }, 50);
  }

  function closeDrawer() {
    if (!drawer || !isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tsw-cart-drawer-open');
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    drawer.addEventListener('change', function (e) {
      var qtySelect = e.target.closest('[data-cart-drawer-qty]');
      if (!qtySelect) return;

      var itemEl = qtySelect.closest('[data-cart-drawer-item]');
      var key = qtySelect.getAttribute('data-item-key') || (itemEl ? itemEl.getAttribute('data-key') : '');
      var quantity = parseInt(qtySelect.value, 10);
      var currentQty = parseInt(qtySelect.getAttribute('data-current-qty'), 10);

      if (!key || isNaN(quantity) || quantity < 1 || quantity === currentQty) return;

      qtySelect.disabled = true;

      updateQuantity(key, quantity)
        .then(renderCart)
        .catch(function () {
          return fetchCart().then(renderCart);
        })
        .finally(function () {
          qtySelect.disabled = false;
        });
    });

    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-drawer-remove]');
      if (!removeBtn) return;

      e.preventDefault();

      var itemEl = removeBtn.closest('[data-cart-drawer-item]');
      var key =
        removeBtn.getAttribute('data-cart-drawer-remove') ||
        (itemEl ? itemEl.getAttribute('data-key') : '');
      if (!key) return;

      removeBtn.disabled = true;

      updateQuantity(key, 0)
        .then(renderCart)
        .catch(function () {
          return fetchCart().then(renderCart);
        })
        .finally(function () {
          removeBtn.disabled = false;
        });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  if (noteEl) {
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        updateNote(noteEl.value).catch(function () {});
      }, 600);
    });
  }

  if (checkoutBtn) {
    checkoutBtn.setAttribute('href', '/checkout');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-drawer-open]');
    if (!openBtn) return;
    e.preventDefault();
    openDrawer();
  });

  window.TSWCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function () {
      return fetchCart().then(renderCart);
    },
  };

  function finishAddToCart(productInstance) {
    ensureCartCountNodes();

    if (productInstance && typeof productInstance._hideErrorMessage === 'function') {
      productInstance._hideErrorMessage();
    }
    if (productInstance && typeof productInstance._handleButtonLoadingState === 'function') {
      productInstance._handleButtonLoadingState(false);
    }

    return fetchCart()
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (productInstance && typeof productInstance._setCartCountBubble === 'function') {
          productInstance._setCartCountBubble(cart.item_count);
        }
        openDrawer();
      })
      .catch(function () {
        openDrawer();
      });
  }

  function patchThemeProduct() {
    if (!window.theme || !theme.Product || !theme.Product.prototype) return false;
    var proto = theme.Product.prototype;
    if (proto.__tswCartDrawerPatched) return true;
    proto.__tswCartDrawerPatched = true;

    ensureCartCountNodes();

    var originalSetBubble = proto._setCartCountBubble;
    if (typeof originalSetBubble === 'function') {
      proto._setCartCountBubble = function (quantity) {
        ensureCartCountNodes();
        var bubble = document.querySelector('[data-cart-count-bubble]');
        var count = document.querySelector('[data-cart-count]');
        if (!bubble || !count) {
          updateCartCount(quantity);
          return;
        }
        try {
          return originalSetBubble.call(this, quantity);
        } catch (err) {
          updateCartCount(quantity);
        }
      };
    }

    /* Theme expects cart-popup DOM — replaced by cart drawer */
    proto._setupCartPopup = function () {
      return finishAddToCart(this);
    };

    proto._updateCartPopupContent = function () {};

    proto._showCartPopup = function () {
      return finishAddToCart(this);
    };

    return true;
  }

  ensureCartCountNodes();

  if (!patchThemeProduct()) {
    document.addEventListener('DOMContentLoaded', patchThemeProduct);
  }
})();
